import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { SectionGG } from '../../oasis-sections/section-gg';
import { OASIS } from '../../oasis-types';
import { fieldSetValidate, isActive, isTimepoint, TEMP_VERSION } from '../util';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionGGConsistency = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    const payload = input;
    if (!isActive(SectionGG.gg0110, TEMP_VERSION, payload.SectionA?.m0100) &&
        !isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100)) {
        return;
    }
    const gg0110 = payload.SectionGG?.gg0110;
    // GG-consistency-5500 (a) If GG0110Z=[1], then all items from GG0110A through GG0110E must be equal to [0].
    if (gg0110?.length &&
        fieldSetValidate({
            input: gg0110,
            ifChecked: ['GG0110Z'],
            notChecked: ['GG0110A', 'GG0110B', 'GG0110C', 'GG0110D', 'GG0110E'],
        })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `-5500 (a) If GG0110Z is checked, then all items from GG0110A through GG0110E must not be checked.`,
            path: ['SectionGG', 'gg0110'],
        });
    }
    // (b) If GG0110Z=[0], then at least one of the items GG0110A through GG0110E must be equal to [1].
    if (!gg0110?.length && isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `-5500 (b) If GG0110Z is not checked, then at least one of the items GG0110A through GG0110E must be checked.`,
            path: ['SectionGG', 'gg0110'],
        });
    }
};
// GG-consistency-5500 GG0110 Consistency:
// a) If GG0110Z=[1], then all items from GG0110A through GG0110E must be equal to [0].
// b) If GG0110Z=[0], then at least one of the items GG0110A through GG0110E must be equal to [1].
// c) If GG0110Z=[-], then at least one item from GG0110A through GG0110E must equal [-], and all remaining items must equal [0,-].
